/* eslint-disable react/no-array-index-key */
import { Box, Collapse, FormControlLabel, Switch, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import RadioGroup from '../../forms/RadioGroup';
import CollapsiblePaper from '../../shared/CollapsiblePaper';
import TargetingAudiencesTable from './TargetingAudiencesTable';

function TargetingAudiences() {
  const { watch } = useFormContext();

  // audiences and maybe excludedAudiences can be null values from the server.
  // If they are, it means they are not available due to configuration.
  // Eg. if target_strategy is 'geofencing', `audiences` will be null.
  // Thus we need null checks in the JSX.
  const audiences = watch('annotatedProfileTargeting');
  const excludedAudiences = watch('annotatedBlacklistedSegments');

  const audienceSegmentsCount = useMemo(
    () => audiences?.filter((audience) => audience.type === 'custom').length || 0,
    [audiences]
  );

  const excludedAdienceSegmentsCount = useMemo(() => excludedAudiences?.length || 0, [excludedAudiences]);

  const [openExlude, setOpenExclude] = React.useState(excludedAdienceSegmentsCount > 0 || audiences === null);

  return (
    <CollapsiblePaper sessionKey="audiences" title={`Audiences (${audienceSegmentsCount + excludedAdienceSegmentsCount})`}>
      {audiences && (
        <Box py={2}>
          <Typography pb={1}>Targeting Type</Typography>
          <RadioGroup
            name="geocookieOrTargeting"
            options={[
              {
                label: 'AND Targeting',
                value: false,
              },
              {
                label: 'OR Targeting',
                value: true,
              },
            ]}
            defaultValue={false}
            normalizeOutput={(e) => e.target.value === 'true'}
          />
        </Box>
      )}
      {audiences && (
        <Box pb={2}>
          <Typography my={2}>Audience Segments</Typography>
          <TargetingAudiencesTable name="annotatedProfileTargeting" />
        </Box>
      )}
      {excludedAudiences && (
        <Box pb={2}>
          <FormControlLabel
            label="Excluded Audience Segments"
            control={<Switch onChange={(e) => setOpenExclude(e.target.checked)} defaultChecked={openExlude} />}
          />
          <Collapse in={openExlude} timeout="auto" unmountOnExit={false} sx={{ marginTop: 1 }}>
            <TargetingAudiencesTable name="annotatedBlacklistedSegments" exclude />
          </Collapse>
        </Box>
      )}
    </CollapsiblePaper>
  );
}

export default TargetingAudiences;
